/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { certificateClientControllerFindAllV1 } from '../fn/certificate-client/certificate-client-controller-find-all-v-1';
import { CertificateClientControllerFindAllV1$Params } from '../fn/certificate-client/certificate-client-controller-find-all-v-1';
import { certificateClientControllerFindByIdV1 } from '../fn/certificate-client/certificate-client-controller-find-by-id-v-1';
import { CertificateClientControllerFindByIdV1$Params } from '../fn/certificate-client/certificate-client-controller-find-by-id-v-1';
import { CertificateDto } from '../models/certificate-dto';

@Injectable({ providedIn: 'root' })
export class CertificateClientService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `certificateClientControllerFindAllV1()` */
  static readonly CertificateClientControllerFindAllV1Path = '/api/v1/certificates/client';

  /**
   * 인증서/특허 전체 조회 (클라이언트).
   *
   * 노출 설정된 인증서/특허 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `certificateClientControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateClientControllerFindAllV1$Response(params?: CertificateClientControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CertificateDto>>> {
    const obs = certificateClientControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 인증서/특허 전체 조회 (클라이언트).
   *
   * 노출 설정된 인증서/특허 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `certificateClientControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateClientControllerFindAllV1(params?: CertificateClientControllerFindAllV1$Params, context?: HttpContext): Observable<Array<CertificateDto>> {
    const resp = this.certificateClientControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<CertificateDto>>): Array<CertificateDto> => r.body)
    );
  }

  /** Path part for operation `certificateClientControllerFindByIdV1()` */
  static readonly CertificateClientControllerFindByIdV1Path = '/api/v1/certificates/client/{id}';

  /**
   * 인증서/특허 상세 조회 (클라이언트).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `certificateClientControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateClientControllerFindByIdV1$Response(params: CertificateClientControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CertificateDto>> {
    const obs = certificateClientControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 인증서/특허 상세 조회 (클라이언트).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `certificateClientControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateClientControllerFindByIdV1(params: CertificateClientControllerFindByIdV1$Params, context?: HttpContext): Observable<CertificateDto> {
    const resp = this.certificateClientControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CertificateDto>): CertificateDto => r.body)
    );
  }

}
